import { useDecision } from '@optimizely/react-sdk'
import { useSelector } from 'react-redux'

import { getIsAuthenticated } from 'selectors/auth'

export function useRecipeGroupingsEnabled() {
  const isAuthenticated = useSelector(getIsAuthenticated)
  const [contextualSides] = useDecision('turnips_ofx_recipe_groupings')

  return isAuthenticated && contextualSides.variationKey === 't1'
}
